<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppHeader from '@/components/app/AppHeader.vue'
import { OptionsSnackbar } from '@haskoning/vue-component-library'
import router from '@/router'

// This await makes the component async, triggering Suspense fallback
await router.isReady()
</script>

<template>
  <AppHeader />
  <v-main>
    <RouterView />
  </v-main>
  <OptionsSnackbar style="z-index: 3000" :excluded-http-methods="['GET', 'OPTIONS']" />
</template>
